import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import { t } from '../../../i18n';
import { loadCoursesHomeInformation } from './redux/actions';
import { getHomeState } from '../../selectors';
import { logError } from '../../../utilities/log';
import InformatinalBlock from './components/informational-block/index';
import GetStartedBlock from './components/get-started-block/index';
import ReviewsCarousel from '../../components/reviews-carousel/index';
import CourseVideoModal from '../../components/course-video-modal';
import CoursesCoverImage from '../../components/courses-cover-image';
import getCampaignPromocode from '../../getCampaignPromocode';
import CoursesList from '../../components/courses-list';
import './styles.scss';

const HomeScreen = () => {
  const [currentVideo, setCurrentVideo] = useState(null);
  const dispatch = useDispatch();
  const { data, isLoading, hasError } = useSelector(getHomeState);

  useEffect(() => {
    const loadHomeData = async () => {
      try {
        const campaignPromocode = getCampaignPromocode();
        dispatch(loadCoursesHomeInformation({ promocode: campaignPromocode }));
      } catch (e) {
        logError('Courses/Home', 'Unhandled error when loading home page data', { message: e.message });
      }
    };
    loadHomeData();
  }, []);

  const handlePlayVideo = video => {
    setCurrentVideo(video);
  };

  if (hasError) {
    return <Alert variant="danger">{t('SERVER_ERROR')}</Alert>;
  }

  return (
    <Container fluid className="home-screen">
      <CoursesCoverImage />
      <div className="home-screen__available-courses-block">
        <CoursesList
          mainTitle={t('DIGITAL_COURSES.HOME_SCREEN.AVAILABLE_COURSES.MAIN_TITLE')}
          courses={data.availableCoursesDataSource}
          onPlayCoursePreview={handlePlayVideo}
          isLoading={isLoading}
          isAvailableCourses
        />
      </div>
      <InformatinalBlock />
      <GetStartedBlock />
      {data.latestCoursesDataSource.length > 0 && (
        <div className="home-screen__latest-courses-block">
          <CoursesList
            topTitle={t('DIGITAL_COURSES.HOME_SCREEN.LATEST_COURSES.TOP_TITLE')}
            mainTitle={t('DIGITAL_COURSES.HOME_SCREEN.LATEST_COURSES.MAIN_TITLE')}
            courses={data.latestCoursesDataSource}
            onPlayCoursePreview={handlePlayVideo}
            isLoading={isLoading}
          />
        </div>
      )}
      {data.popularCoursesDataSource.length > 0 && (
        <div className="home-screen__popular-courses-block">
          <CoursesList
            topTitle={t('DIGITAL_COURSES.HOME_SCREEN.POPULAR_COURSES.TOP_TITLE')}
            mainTitle={t('DIGITAL_COURSES.HOME_SCREEN.POPULAR_COURSES.MAIN_TITLE')}
            courses={data.availableCoursesDataSource}
            onPlayCoursePreview={handlePlayVideo}
            isLoading={isLoading}
          />
        </div>
      )}
      {data.reviewsDataSource.length > 0 && (
        <div className="home-screen__reviews-block">
          <h2 className="home-screen__reviews-title">{t('DIGITAL_COURSES.HOME_SCREEN.REVIEWS.TITLE')}</h2>
          <p className="home-screen__reviews-description">{t('DIGITAL_COURSES.HOME_SCREEN.REVIEWS.DESCRIPTION')}</p>
          <ReviewsCarousel reviews={data.reviewsDataSource} isLoading={isLoading} />
        </div>
      )}
      <CourseVideoModal visible={!!currentVideo} video={currentVideo} onClose={() => setCurrentVideo(null)} />
    </Container>
  );
};

export default HomeScreen;
